module.exports = __webpack_public_path__ + "static/clutch@2x-59fa6341385d4f4f55833243ab396a73.png";